import React from 'react';
import styles from './InspectionChecklist.module.scss';
import { useTranslation } from 'react-i18next';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { Switch, styled } from '@mui/material';


//TODO: Convert it to SCSS Styling
const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 48,
    height: 24,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 20,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(24px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 1,
      '&.Mui-checked': {
        transform: 'translateX(24px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#1976D2',
          ...theme.applyStyles('dark', {
            backgroundColor: '#1976D2',
          }),
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 20,
      height: 20,
      borderRadius: 10,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 24 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
      ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255,255,255,.35)',
      }),
    },
  }));

interface InspectionChecklistProps extends DynamicComponentProps {
    defaultHeader: string;
    completionTranslationKey: string;
    moduleName?: string;
}

export const InspectionChecklist: React.FC<InspectionChecklistProps> = ({ 
    inspection, 
    structure, 
    onCheckedModuleChange, 
    defaultHeader, 
    completionTranslationKey,
    moduleName
}: InspectionChecklistProps) => {
    const { t } = useTranslation();
    // Use moduleName if provided, otherwise fall back to structure.name for backward compatibility
    const moduleNameToUse = moduleName || structure.name;
    const isChecked = inspection.checkedModules?.includes(moduleNameToUse) || false;

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onCheckedModuleChange) {
            onCheckedModuleChange(moduleNameToUse, event.target.checked);
        }
    };

    return (
        <div className={styles.formContainer}>
            <h2 className={styles.header}>{t(structure.header || defaultHeader)}</h2>
            <div className={styles.inputGroup}>
                <p className={styles.heading}>{t(completionTranslationKey)}</p>
                <AntSwitch checked={isChecked} onChange={handleSwitchChange} inputProps={{ 'aria-label': 'ant design' }} />
            </div>
        </div>
    );
}; 